import { render, staticRenderFns } from "./quantityOfExchange.vue?vue&type=template&id=d67dbf58&scoped=true"
import script from "./quantityOfExchange.vue?vue&type=script&lang=js"
export * from "./quantityOfExchange.vue?vue&type=script&lang=js"
import style0 from "./quantityOfExchange.vue?vue&type=style&index=0&id=d67dbf58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67dbf58",
  null
  
)

export default component.exports